module.exports = __webpack_public_path__ + "img/file.8ba2cd87.svg";